import * as React from 'react'

function SvgGbSct(props) {
	return (
		<svg viewBox="0 0 5 3" width="1em" height="1em" {...props}>
			<defs>
				<clipPath id="gb-sct_svg__a">
					<path d="M0 0h5v3H0z" />
				</clipPath>
			</defs>
			<g clipPath="url(#gb-sct_svg__a)">
				<path fill="#0065BD" d="M0 0h50v30H0z" />
				<path d="M0 0l5 3M0 3l5-3" fill="none" stroke="#fff" strokeWidth={0.6} />
			</g>
		</svg>
	)
}

export default SvgGbSct
